import { render, staticRenderFns } from "./ReportsInvoices.vue?vue&type=template&id=24d60db2&scoped=true&"
import script from "./ReportsInvoices.vue?vue&type=script&lang=js&"
export * from "./ReportsInvoices.vue?vue&type=script&lang=js&"
import style0 from "./ReportsInvoices.vue?vue&type=style&index=0&id=24d60db2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d60db2",
  null
  
)

export default component.exports